import { TableStyle } from './tableStyle';
import React from 'react';
import { Table as AntTable } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { TableProps as AntTableProps } from 'antd';

interface TableProps<T> extends Omit<AntTableProps<T>, 'columns' | 'dataSource'> {
  columns: ColumnsType<T>;
  dataSource: T[];
}

const Table = <T extends object>({
  columns,
  dataSource,
  scroll,
  ...props
}: TableProps<T>) => {
  return (
    <TableStyle>
      <AntTable
        {...props}
        className="table-custom"
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        rowKey="id"
        scroll={scroll}
      />
    </TableStyle>
  );
};

export default Table;
